import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { PackageService } from '@lib/package/package.service';
import { DashboardStatsCardComponent } from '../../../components/dashboard-stats-card/dashboard-stats-card.component';

@Component({
    selector: 'app-count-open-packages',
    imports: [
        DashboardStatsCardComponent
    ],
    templateUrl: './count-open-packages.component.html',
    standalone: true,
    styleUrl: './count-open-packages.component.scss'
})
export class CountOpenPackagesComponent {

    private readonly _packageService = inject(PackageService);
    protected readonly Number = Number;

    openPackagesCountResult = toSignal(
        this._packageService.countOpenPackages().pipe(
            catchError(() => of(null))
        )
    );

    openPackages = computed(() => this.openPackagesCountResult()?.count);

    getPackageCount(): number {
        return this.openPackages() && Number(this.openPackages()) > 0 ? Number(this.openPackages()) : 0;
    }
}
